export const radarOptions = {
  scales: {
    r: {
      min: 0,
      grid: {
        circular: true,
        color: '#474747',
      },
      angleLines: {
        color: '#474747',
      },
      beginAtZero: false,
      stacked: true,
      ticks: {
        stepSize: 2,
        display: false,
      },
    },
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

export const selfAssessmentData = {
  labels: [],
  datasets: [
    {
      fill: true,
      backgroundColor: 'rgba(57, 158, 41, 0.10)',
      borderColor: '#399E29',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      data: [],
    },
    {
      fill: false,
      borderColor: '#7B7B7B',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      data: [],
      borderDash: [10, 5],
    },
  ],
};
